import { computedFrom } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { RightShipInspectionModel, RightShipInspectionType } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
export class DeclarationTab {
    item:RightShipInspectionModel;
    attachments: File[] = [];
    isEdit:boolean = false;
    isRsUser:boolean = false;
    navigateBack: () => void;
    
    private _messageCenterOn: boolean = false;
    @computedFrom('_messageCenterOn')
    get messageCenterOn() {
            return this._messageCenterOn;
    }

    activate(item:RightShipInspectionModel){
        this.item = item;
    }

    constructor(private dialogClientService: DialogClientService, private userClaimsService: UserClaimsService, private configService: ConfigService){
        this.isRsUser = this.userClaimsService.hasPermission(Claims.RightShipUser);
        this._messageCenterOn = this.configService.config.settings.messageCenterOn;
        console.log("messageCenterOn",this._messageCenterOn);
    }
    
    showBadgeExampleDialog(event) {
        event.stopPropagation();
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.RightShipInspectionBadgeExampleDialog, null, true, false, false);
    }

    showTermsDialog() {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.RightShipInspectionTermsDialog, null, true, false, false);
    }

    @computedFrom('isEdit', 'isDry', 'isRsUser')
    get showTermsAndConditions(): boolean {
        return this.isDry  && (!this.isEdit || this.isRsUser);
    }
    
    @computedFrom('item', "item.rightShipInspectionTypeId")
    get isCargill() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.CargillSurvey;
    }
    
    @computedFrom('item', "item.rightShipInspectionTypeId")
    get isDry() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.RightShipInspection;
    }
    
    @computedFrom('item', "item.rightShipInspectionTypeId")
    get isWet() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.TankerInspection;
    }

    gotoStep6(event) {
        event.stopPropagation();
        if(this.navigateBack) this.navigateBack();
    }
}